export class Developer {
  constructor(name, imageDev, rol) {
    this.name = name;
    this.imageDev = imageDev;
    this.rol = rol;
  }
}
